export const DRAG_AND_DROP_PRODUCT = "DRAG_AND_DROP_PRODUCT";
////////////////////////////////////

// FULLY_Fit listing
export const GET_FULLY_FIT_LIST = "GET_FULLY_FIT_LIST";
export const GET_FULLY_FIT_LIST_SUCCESS = "GET_FULLY_FIT_LIST_SUCCESS";
export const GET_FULLY_FIT_LIST_ERROR = "GET_FULLY_FIT_LIST_ERROR";

// Edit FULLY_Fit
export const EDIT_FULLY_FIT = "EDIT_FULLY_FIT";
export const EDIT_FULLY_FIT_SUCCESS = "EDIT_FULLY_FIT_SUCCESS";
export const EDIT_FULLY_FIT_ERROR = "EDIT_FULLY_FIT_ERROR";

// Add FULLY_Fit
export const ADD_FULLY_FIT = "ADD_FULLY_FIT";
export const ADD_FULLY_FIT_SUCCESS = "ADD_FULLY_FIT_SUCCESS";
export const ADD_FULLY_FIT_ERROR = "ADD_FULLY_FIT_ERROR";

// delete
export const DELETE_FULLY_FIT = "DELETE_FULLY_FIT";
export const DELETE_FULLY_FIT_SUCCESS = "DELETE_FULLY_FIT_SUCCESS";
export const DELETE_FULLY_FIT_ERROR = "DELETE_FULLY_FIT_ERROR";
